import { memo, useEffect, useRef } from "react";
import * as Common from "bodycodi/cmap/app/js/common";

import "bodycodi/cmap/app/css/common/picker.css";

function Picker({
  data,
  onChange,
  index,
  current = 0,
  height = 40,
  align = "",
  activeMode = "blue",
}) {
  let touchY = 0;
  let moveItemCount = 0;
  let itemHeight = height;
  let currentIndex = current;
  let max = data.length - 1;
  let min = 0;
  let animating = false;
  let _moveToTimer = null;
  let translateY = -currentIndex * itemHeight;
  let scroll = useRef();
  let view = useRef();

  useEffect(() => {
    view.current.addEventListener("touchstart", handleStart, false);
    view.current.addEventListener("touchmove", handleMove, false);
    view.current.addEventListener("touchend", handleEnd, false);
    //view.addEventListener('mousedown', this.handleContentMouseDown, false);

    return () => {
      if (!Common.isEmpty(view.current)) {
        view.current.removeEventListener("touchstart", handleStart, false);
        view.current.removeEventListener("touchmove", handleMove, false);
        view.current.removeEventListener("touchend", handleEnd, false);
      }
    };
  });

  useEffect(() => {
    updateClass();
  }, [data]);

  useEffect(() => {
    moveTo();
  }, []);

  const isUndefind = (value) => {
    return typeof value === "undefined";
  };

  const clearTransition = (obj) => {
    addPrefixCss(obj, { transition: "" });
  };

  const chekIsUpdateItem = (direction, y) => {
    //아이템 절반 이상 넘어가면 true currentIndex min 0
    let chekc =
      direction === 1
        ? itemHeight * currentIndex + itemHeight / 2 < -y
        : itemHeight * currentIndex - itemHeight / 2 > -y;
    return chekc;
  };

  const update = (d) => {
    if (d === 1) {
      if (currentIndex < max) {
        currentIndex++;
      }
    } else {
      if (currentIndex > min) {
        currentIndex--;
      }
    }
    updateClass();
  };

  const updateClass = () => {
    let children = scroll.current.children;
    for (let i = 0; i < children.length; i++) {
      children[i].classList.remove(activeMode);
    }
    children[currentIndex].classList.add(activeMode);
  };

  const moveToNext = (d) => {
    if (d === -1 && moveItemCount) {
      //update(1);
    } else if (d === 1 && moveItemCount) {
      //update(-1);
    }
    moveTo(currentIndex);
  };

  const moveTo = () => {
    animating = true;

    addPrefixCss(scroll, { transition: "transform .2s ease-out" });

    translateY = -currentIndex * itemHeight;
    updateCss(translateY);

    _moveToTimer = setTimeout(() => {
      animating = false;
      onChange(index, data[currentIndex]);
      addPrefixCss(scroll, { transition: "" });
    }, 200);
  };

  const handleStart = (e) => {
    touchY =
      !isUndefind(e.targetTouches) && !isUndefind(e.targetTouches[0])
        ? e.targetTouches[0].pageY
        : e.pageY;

    moveItemCount = 0;
  };

  const handleMove = (e) => {
    let touchY1 =
      !isUndefind(e.targetTouches) && !isUndefind(e.targetTouches[0])
        ? e.targetTouches[0].pageY
        : e.pageY;
    let dir = touchY1 - touchY;
    let translateY1 = dir + translateY;
    let direction = dir > 0 ? -1 : 1;
    if (chekIsUpdateItem(direction, translateY1)) {
      moveItemCount = direction === 1 ? moveItemCount + 1 : moveItemCount - 1;
      update(direction);
    }
    //translateY = translateY1;
    updateCss(translateY1);
  };

  const handleEnd = (e) => {
    let touchY1 =
      !isUndefind(e.targetTouches) && !isUndefind(e.targetTouches[0])
        ? e.targetTouches[0].pageY
        : e.pageY;
    let dir = touchY1 - touchY;

    let direction = dir > 0 ? -1 : 1;
    moveToNext(direction);
  };

  const clickItem = (i) => () => {
    currentIndex = i;
    moveTo();
    updateClass();
  };

  let updateCss = (y) => {
    addPrefixCss(scroll, { transform: `translateY(${y}px)` });
  };

  let style = formatCss({
    transform: `translateY(${translateY}px)`,
  });

  let scrollItem = data.map((d, i) => {
    return (
      <div className={`picker-item ${align}`} key={d.value} onClick={clickItem(i)}>
        {d.text}
      </div>
    );
  });

  return (
    <div className="picker">
      <div className="picker-col" ref={view}>
        <div className="picker-pointer">
          <div className="picker-pointer-scroll" ref={scroll} style={style}>
            {scrollItem}
          </div>
        </div>
      </div>
    </div>
  );
}

function camelCase(str) {
  return str.replace(/-([a-z])/g, ($0, $1) => $1.toUpperCase()).replace("-", "");
}

function formatCss(props) {
  const prefixs = ["-webkit-", "-moz-", "-ms-"];
  const result = {};
  const regPrefix = /transform|transition/;
  for (const key in props) {
    if (props.hasOwnProperty(key)) {
      const styleValue = props[key];
      if (regPrefix.test(key)) {
        for (let i = 0; i < prefixs.length; i++) {
          const styleName = camelCase(prefixs[i] + key);
          result[styleName] = styleValue.replace(regPrefix, `${prefixs[i]}$&`);
        }
      }
      result[key] = styleValue;
    }
  }
  return result;
}

function addPrefixCss(element, props) {
  const formatedProps = formatCss(props);
  for (const key in formatedProps) {
    if (formatedProps.hasOwnProperty(key)) {
      element.current.style[key] = formatedProps[key];
    }
  }
}

export default memo(Picker);
